module.exports = __webpack_public_path__ + "static/media/37.db95c9a0.png";